module.exports = __webpack_public_path__ + "static/img/dongguanwei.0018c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dongguanwei.png
// module id = Xn91
// module chunks = 1